// extracted by mini-css-extract-plugin
module.exports = {"container":"panel_container__bvYk8","header":"panel_header__3Sxf0","footer":"panel_footer__1jj-S"};